import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';

function RatingDistributionGraph({ data, averageRating }: { data: any, averageRating: string }) {

    const options: ApexOptions = {
        colors: ["#EF4444", "#FBBF24", "#9CA3AF", "#60A5FA", "#008FFB"],
        states: {
            hover: {
                filter: {
                    type: 'lighten', // Options: darken, lighten, none
                }
            },
            active: {
                filter: {
                    type: 'darken', // Options: darken, lighten, none
                }
            }
        },
        chart: {
            type: "donut",
            animations: {
                enabled: true,
                speed: 300,
            },
        },
        fill: {
            type: 'solid',
        },
        stroke: {
            width: 3,
            colors: ["#FFFFFF"]
        },
        labels: ["1 Star", "2 Stars", "3 Stars", "4 Stars", "5 Stars"], // Rating categories
        tooltip: {
            y: {
                formatter: (val: number) => `${val} reviews`,
            },
        },
        legend: {
            position: "bottom",
        },
        plotOptions: {
            pie: {
                donut: {
                    size: "60%",
                    labels: {
                        show: true,
                        total: {
                            show: true,
                            label: "Average",
                            fontSize: '14px',
                            fontWeight: 600,
                            color: '#111',
                            formatter: () => averageRating,
                        },
                        name: {
                            show: true,
                            fontSize: '16px',
                            color: '#111'
                        },
                        value: {
                            show: true,
                            fontSize: '32px',
                            fontWeight: 300,
                            color: '#1D4ED8'
                        },
                    },
                }
            }
        },
        dataLabels: {
            enabled: true, // Show labels inside the pie chart
        }
    };

    return (
        <div>
            <ReactApexChart
                options={options}
                series={data}
                type="donut"
                height={350} />
        </div >
    );
}

export default RatingDistributionGraph;